import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import Logo from '../Logo.js';
import data from '../logos/ms-global.js';

var LogoMsGlobal = function LogoMsGlobal(props) {
  return React.createElement(Logo, _extends({}, props, {
    data: data
  }));
};

LogoMsGlobal.displayName = 'LogoMsGlobal';
export default LogoMsGlobal;